// Ensure Firebase initialization at the entry point of your application
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDQNjKlO05LXbjRT9f6IAcTYw2WZfKxx4U",
    authDomain: "ckayb-47be2.firebaseapp.com",
    projectId: "ckayb-47be2",
    storageBucket: "ckayb-47be2.appspot.com",
    messagingSenderId: "531303409580",
    appId: "1:531303409580:web:d9cafe5117525e27e83c09",
    measurementId: "G-B8KF9SBVFZ"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);

export { app, auth, firestore }; // Export firestore here
export default firebaseConfig; // Add this line
